<script setup>
import StringSwitch from '@/components/reusable/StringSwitch.vue'
import { useLoaderStore } from "@/store/loader"
import { computed , ref } from 'vue'
import {updateEntityConfig as updateEntityConfigService, createEntityConfig} from "@/services/entityService"
import {availableSubSystems} from '@/config'

const loader = useLoaderStore()
const props = defineProps({
  modelValue: Object,
  default: () => ({
      mfa: false,
      subsystemAccess: []
    }),
  entityState: Object,
  entityType: String
})

const loading = ref(false)

const form = ref({
  subsystemAccess: [...(props.modelValue?.subsystemAccess || [])],
  mfa: props.modelValue?.mfa ?? false,
})
const emit = defineEmits(['update:modelValue'])

const remainingSubsystems = computed(() => {
  return availableSubSystems.filter(
    s => !form.value.subsystemAccess.includes(s)
  )
})

function removeSubsystem(index) {
  form.value.subsystemAccess.splice(index, 1)
}

function singularizeEntityType(value) {
  if (!value || typeof value !== 'string') {
    return value
  }

  // companies -> company
  if (value.endsWith('ies')) {
    return value.slice(0, -3) + 'y'
  }

  if (value.endsWith('s')) {
    return value.slice(0, -1)
  }

  return value
}

function sortPriority(entityType){
  let priorityList = {
    "department": "1",
    "company": "2",
    "organisation": "3"
  }
  return priorityList[entityType] || "4"
}

async function submit() {
  try {
    loading.value = true

    const payload = {
      subsystemAccess: form.value.subsystemAccess,
      mfa: form.value.mfa,
      id: props.modelValue?._id || form.value?._id
    }

    if(props.modelValue?._id || form.value?._id)
    await updateEntityConfigService(payload)
    else {
      payload.entityType = singularizeEntityType(props.entityType)
      payload.entityId = props.entityState._id
      payload.entityPath = props.entityState.path
      payload.priority = sortPriority(payload.entityType)
      const response = await createEntityConfig(payload)
      form.value._id = response.data?.entityconfigCreateOne?.record?._id

    }  

  } catch (err) {
    console.error(err)
  } finally {
    loading.value = false
  }
}

function updateEntityConfig (value){
  form.value.mfa = value
}

function addSubsystem(subsystem) {
  if (!form.value.subsystemAccess.includes(subsystem)) {
    form.value.subsystemAccess.push(subsystem)
  }
}

</script>

<template>
  <v-container fluid>
  <v-card class="mb-12">
      <v-card-title>Permission Configuration
      </v-card-title>
      <v-card-text>
      <v-row>
        <!-- <VCol cols="12" md="6">
          <VTextField v-model="modelValue.entityId" label="Entity ID" variant="filled" density="compact" readonly />
        </VCol> -->

        <!-- <VCol cols="12" md="12">
          <VTextField v-model="modelValue.entityType" label="Affected Scope" variant="filled" density="compact" readonly />
        </VCol> -->

        <!-- <VCol cols="12" md="6">
          <VTextField v-model="modelValue.entityPath" label="Path" variant="filled" density="compact" />
        </VCol> -->
<!-- 
        <VCol cols="12" md="6">
          <VTextField v-model="modelValue.priority" label="Priority" variant="filled" density="compact" disabled/>
        </VCol> -->

        <v-col cols="12" md="6">
          <v-switch
            v-model="form.mfa"
            label="MFA"
            :color="form.mfa ? 'green' : 'red'"
          />          
        </v-col>
        <!-- <VCol cols="12" md="6">
          <VSwitch v-model="modelValue.isDeleted" label="Deleted" inset density="compact" />
        </VCol> -->

        <!-- subsystemAccess -->
  
        <v-col cols="12">
          <div class="text-caption mb-1">
            Subsystem Access
          </div>

          <div class="d-flex flex-wrap ga-2">
            <v-btn
              v-for="(item, i) in form.subsystemAccess"
              :key="item"
              size="small"
              variant="tonal"
              color="primary"
              @click="removeSubsystem(i)"
            >
              {{ item }}

              <v-icon end size="16">
                mdi-close
              </v-icon>
            </v-btn>
          </div>
        </v-col>

        <!-- Available -->
        <v-col cols="12">
          <div class="text-caption mb-1">
            All Other Available Subsystems
          </div>

          <div class="d-flex flex-wrap ga-2">
            <v-btn
              v-for="item in remainingSubsystems"
              :key="item"
              size="small"
              variant="outlined"
              color="secondary"
              @click="addSubsystem(item)"
            >
              {{ item }}

              <v-icon end size="16">
                mdi-plus
              </v-icon>
            </v-btn>
          </div>
        </v-col>

        <v-col cols="12">
          <v-btn
            color="primary"
            :loading="loading"
            @click="submit"
          >
            Save Changes
          </v-btn>
        </v-col>
      </v-row>
  </v-card-text>
   </v-card>
  </v-container>
</template>